// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__tFr1T","wrongPage":"App_wrongPage__fQkQi"};